import React from 'react';
import { motion, useAnimation } from 'framer-motion';
import { Card, Box, useMediaQuery, useTheme, Typography } from '@mui/material'; // Fixed useTheme import source
import BookmarkIcon from '@mui/icons-material/Bookmark';
import clsx from 'clsx';
import { Bookmark, BookmarkBorder, Check, Remove } from '@mui/icons-material';
import BookmarkWithInnerIcon from './BookmarkWithInnerIcon';

export default function SwipeablePostCard({
    children,
    elevation,
    sx,
    className,
    onBookmark,
    isBookmarked,
    onCardClick,
    cardRef
}) {
    const theme = useTheme();
    const primaryColor = theme.palette.primary.main.trim();

    // only enabled on mobile devices
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const controls = useAnimation();
    const ACTION_THRESHOLD = -20;

    const handleDragEnd = (event, info) => {
        if (!isMobile) return;

        const shouldTriggerBookmark = info.offset.x < ACTION_THRESHOLD;

        controls.start({
            x: 0,
            transition: { type: 'spring', stiffness: 300, damping: 30 }
        }).then(() => {
            if (shouldTriggerBookmark) {
                onBookmark?.();
            }
        });
    };

    return (
        <Box className="mx-1 sm:mx-3 md:mx-auto my-1 md:my-2 px-2 sm:px-3" sx={{ position: 'relative', overflow: 'hidden'}}>

            <div className='relative'>
                <div
                    className={clsx("absolute inset-y-0 right-0 w-[190px] mb-0 mt-0 pl-20 flex flex-col gap-2 items-center justify-center rounded-r-lg z-1")}
                    style={{ backgroundColor: isBookmarked ? theme.palette.primary.contrastText : primaryColor }}
                >
                    {/* {isBookmarked? <Bookmark sx={{color: primaryColor, fontSize: 2*18}} /> : <BookmarkBorder sx={{color: theme.palette.primary.contrastText, fontSize: 2*18}} />} */}
                    <BookmarkWithInnerIcon
                        InnerIcon={isBookmarked ? Remove : Check}
                        bookmarkColor={isBookmarked ? primaryColor : theme.palette.primary.contrastText}
                        innerColor={isBookmarked ? theme.palette.primary.contrastText : primaryColor}
                        bookmarkSize={2 * 18} innerSize={18}
                    />
                    <Typography className="text-md font-semibold" style={{ color: isBookmarked ? primaryColor : theme.palette.primary.contrastText }}>{isBookmarked ? "Unsave" : "Save"}</Typography>
                </div>

                <motion.div
                    drag={isMobile ? "x" : false}
                    dragConstraints={{ left: -100, right: 0 }}
                    dragElastic={0.1}
                    animate={controls}
                    onDragEnd={handleDragEnd}
                    style={{ position: 'relative', zIndex: 2 }}
                >
                    <Card
                        ref={cardRef}
                        elevation={elevation}
                        sx={sx}
                        className={className}
                        onClick={onCardClick}
                    >
                        {children}
                    </Card>
                </motion.div>
            </div>
        </Box>
    );
}